import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "@tools/EnvironmentStorage";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Message, Button, Drawer, Loading } from "@components";
import { IntegrationsAPI } from "providers/IntegrationsAPI";
import ApplePayAddCertificateDrawer from "./ApplePayAddCertificateDrawer";

export default class ApplePayCertificateDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      loading: false,
      file: null,
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async downloadCsrFile() {
    this.setState({ loading: true });

    const environmentId = EnvironmentStorage.getEnvironment().id;

    const certificateResponse = await IntegrationsAPI.getApplePayCertificate(
      environmentId
    );

    if (certificateResponse.getErrors([]).length > 0) {
      this.setState({ loading: false });

      alert({
        text: `Não foi possivel baixar o csr - ${
          certificateResponse.getErrors()[0]
        }`,
      });

      return;
    }

    const certificate = certificateResponse.getData();
    const csrFileUrl = certificate?.csrFileUrl;

    if (csrFileUrl) {
      window.open(csrFileUrl, "_blank");
    }

    this.setState({ loading: false });
  }

  async deleteCertificate() {
    this.setState({
      loading: true,
    });

    const confirmed = await window.confirm({
      text: "Você tem certeza que remover o certificado? Não poderá reverter essa ação.",
      confirmText: "Remover certificado",
      cancelText: "Cancelar",
    });

    if (!confirmed) {
      this.setState({
        loading: false,
      });

      return false;
    }

    const environmentId = EnvironmentStorage.getEnvironment().id;

    const certificateResponse = await IntegrationsAPI.deleteApplePayCertificate(
      environmentId
    );

    if (certificateResponse.getErrors([]).length > 0) {
      this.setState({ loading: false });

      alert({
        text: `Não foi possivel remover o certificado - ${
          certificateResponse.getErrors()[0]
        }`,
      });
    }

    this.setState({
      loading: false,
    });
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const currentConfigs = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "apple_pay"
    );
    const configs = currentConfigs || {};

    if (Object.keys(configs).length > 0) {
      this.setState({
        merchantId: configs?.merchantId,
        merchantName: configs?.merchantName,
      });
    }

    this.setState({
      loadingPage: false,
    });
  }

  render() {
    const { loading, loadingPage, openAddCertificate } = this.state;
    const { onClose } = this.props;

    return (
      <Drawer
        visible
        onClose={onClose}
        closeInFade
        title={"Apple Pay - Certificado"}
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Message className="mb-20" type="warning">
              <p>
                Baixe o arquivo <b>.csr</b> e envie-o na área <b>Merchant Identity</b>{" "}
                do Apple Pay.
              </p>
              <p>
                Depois disso, faça o upload do arquivo <b>.cer</b> para
                finalizar a configuração.
              </p>
            </Message>

            <Button
              design="primary"
              className="mb-10 w-100"
              onClick={() => this.downloadCsrFile()}
              disabled={loading}
            >
              Baixar arquivo .CSR
            </Button>

            <Button
              design="primary"
              className="mb-10 w-100"
              onClick={() =>
                this.setState({
                  openAddCertificate: true,
                })
              }
              disabled={loading}
            >
              Carregar arquivo .CER
            </Button>

            <Button
              design="primary"
              className="mb-10 w-100"
              onClick={() => this.deleteCertificate()}
              disabled={loading}
            >
              Remover certificado
            </Button>
          </div>
        )}

        {openAddCertificate && (
          <ApplePayAddCertificateDrawer
            onClose={() =>
              this.setState({
                openAddCertificate: false,
              })
            }
            onSave={() =>
              this.setState({
                openAddCertificate: false,
              })
            }
          />
        )}
      </Drawer>
    );
  }
}
